export const getConversoesVolume = (state) => state.conversoesVolume.lista
export const getIsCarregandoListaConversoesVolume =
  (state) => state.conversoesVolume.isCarregandoLista
